// removed by extract-text-webpack-plugin
module.exports = {"consentCountryForm":"consentCountryForm-3hxuP","consentNextButton":"consentNextButton-2HvUk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/privacy_center/util/_country.css
// module id = 1255
// module chunks = 1